import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Segment, Grid, Header, Table } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { apiViaje } from "../../../api/viaje";
import { ENTORNO } from "../../../utils/constantes";
import {
  setTitulo,
  getrole,
  getid,
  setPoolingActivado,
} from "../../../utils/variablesLocales";
import HomeIcon from "@mui/icons-material/Home";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import NativeSelect from "@mui/material/NativeSelect";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {
  historial_de_viajes,
  filtrar_por,
  ultimo_mes,
  ultimos_tres_meses,
  ultimos_seis_meses,
  fecha_hora,
  partida,
  DestinoDireccion,
  PrecioSugerido,
  estado,
  nombre_conductor,
  modelo,
  dominio,
  ver_en_google_maps,
  todos,
  punto_de_partida,
  punto_DestinoDireccion,
  conductor,
  pasajero,
  punto_destino,
  descargar,
  sin_datos,
} from "../../../utils/traductor";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DownloadIcon from "@mui/icons-material/Download";
import IconoKms from "@mui/icons-material/LocalTaxi";
import IconoMin from "@mui/icons-material/AccessTime";
import IconoPrecio from "@mui/icons-material/AttachMoney";
import Fade from "@mui/material/Fade";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import PropTypes from "prop-types";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  PDFViewer,
} from "@react-pdf/renderer";
import Swal from "sweetalert2";
import { estiloColores } from "../../../estilos/colores";
import { VerReciboViaje } from "../../../componentes/Administrador_VerReciboViaje/VerReciboViaje";

import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
  borderRadius: "10px",
};

const apiviaje = new apiViaje();

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export function HistorialViajes(props) {
  setTitulo("HistorialViajes");

  const [PrecioSugerido, setPrecioSugerido] = useState("");
  const [FechaHoraSolicitud, setFechaHoraSolicitud] = useState("");
  const [PartidaDireccion, setPartidaDireccion] = useState("");
  const [DestinoDireccion, setDestinoDireccion] = useState("");
  const [Pasajero, setPasajero] = useState("");
  const [Chofer, setChofer] = useState("");
  const [Marca, setMarca] = useState("");
  const [Modelo, setModelo] = useState("");
  const [Color, setColor] = useState("");
  const [Dominio, setDominio] = useState("");
  const [Estado, setEstado] = useState("");
  const [ViajeId, setViajeId] = useState("");
  const [Kms, setKms] = useState("");
  const [Min, setMin] = useState("");

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  const [CantidadRegistros, setCantidadRegistros] = useState(0);

  const DescargarRecibo = async (
    PrecioSugerido,
    FechaHoraSolicitud,
    PartidaDireccion,
    DestinoDireccion,
    Pasajero,
    Chofer,
    Marca,
    Modelo,
    Color,
    Dominio,
    Estado,
    ViajeId,
    Kms,
    Min
  ) => {
    setPrecioSugerido(PrecioSugerido);
    setFechaHoraSolicitud(FechaHoraSolicitud);
    setPartidaDireccion(PartidaDireccion);
    setDestinoDireccion(DestinoDireccion);
    setPasajero(Pasajero);
    setChofer(Chofer);
    setMarca(Marca);
    setModelo(Modelo);
    setColor(Color);
    setDominio(Dominio);
    setEstado(Estado);
    setViajeId(ViajeId);
    setKms(Kms);
    setMin(Min);

    setOpen(true);
  };

  useEffect(() => {
    (async () => {
      //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
      if (getrole() !== "Pasajero") {
        navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
      }
      ///////////////////////////////////////////////////////
      //Poner por defecto que traiga ULTIMO MES
    })();
  });

  ////////////////////////////////

  const [periodoSeleccionado, setPeriodoSeleccionado] = useState(-1);
  const [historial, setHistorial] = useState(null);
  const obtenerMisViajesPasajero = async (Id, Periodo) => {
    try {
      if (Periodo === -1) {
        setCantidadRegistros(0);
      } else {
        const respuesta = await apiviaje.obtenerMisViajesPasajero(Id, Periodo);

        if (respuesta.length === 0) {
          setCantidadRegistros(0);
        } else {
          setHistorial(respuesta);
          setCantidadRegistros(respuesta.length);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  function formatearFecha(fecha) {
    const opcionesFecha = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };

    const opcionesHora = {
      hour: "2-digit",
      minute: "2-digit",
    };

    const fechaFormateada = new Date(fecha);

    const fechaFormateadaTexto = fechaFormateada.toLocaleDateString(
      "es-ES",
      opcionesFecha
    );
    const horaFormateadaTexto = fechaFormateada.toLocaleTimeString(
      "es-ES",
      opcionesHora
    );
    return `${fechaFormateadaTexto} ${horaFormateadaTexto}`;
  }

  var historialRegistros = [];

  if (historial) {
    for (let i = 0; i < historial.length; i++) {
      historialRegistros.push({
        id: historial[i]._id,
        FechaHoraSolicitud: formatearFecha(historial[i].FechaHoraSolicitud),
        PartidaDireccion: historial[i].PartidaDireccion,
        DestinoDireccion: historial[i].DestinoDireccion,
        PrecioSugerido: historial[i].PrecioSugerido,
        Estado: historial[i].Estado,
        Chofer: historial[i].Chofer,
        Marca: historial[i].Marca,
        Modelo: historial[i].Modelo,
        Color: historial[i].Color,
        Dominio: historial[i].Dominio,
        Pasajero: historial[i].Pasajero,
        Kms: historial[i].Kms,
        Min: historial[i].Min,
        ViajeId: historial[i]._id,
      });
    }
  }

  const navigate = useNavigate();

  const navigateToInicio = () => {
    //pooling
    //setPoolingActivado(true);

    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <div className="divPrincipal_ImportarNomina">
        <AppBar style={{ background: "#DC030E" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={navigateToInicio}
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <HomeIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {historial_de_viajes}
            </Typography>
            <img
              src={logoLocalPoint}
              style={{ marginTop: "1px" }}
              width="75"
              alt="Logo"
            />
          </Toolbar>
        </AppBar>
        <Toolbar id="back-to-top-anchor" />
        <Container>
          <Box sx={{ my: -6 }}>
            <Segment style={estiloSegmento.Administrador}>
              <Grid
                textalign="center"
                container
                style={{
                  padding: "3em 0em",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="ingresar">
                  <Grid.Row style={{ width: "100%" }}>
                    <Grid.Column style={{ width: "100%" }}>
                      <Box
                        //component="form"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          "& > :not(style)": { m: 1, width: "100%" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <NativeSelect
                          value={periodoSeleccionado}
                          onChange={(event) => {
                            const nuevoPeriodo = event.target.value;
                            setPeriodoSeleccionado(nuevoPeriodo);
                            obtenerMisViajesPasajero(getid(), nuevoPeriodo);
                          }}
                          inputProps={{
                            name: "filtro",
                            id: "filtro",
                          }}
                          style={{ width: "100%" }}
                        >
                          <option value={-1}> &nbsp;{filtrar_por}:</option>
                          <option value={1}>
                            {" "}
                            &nbsp;
                            {ultimo_mes}
                          </option>
                          <option value={3}>
                            {" "}
                            &nbsp;
                            {ultimos_tres_meses}
                          </option>
                          <option value={6}>
                            {" "}
                            &nbsp;
                            {ultimos_seis_meses}
                          </option>
                          <option value={0}> &nbsp;{todos}</option>
                        </NativeSelect>

                        {CantidadRegistros === 0 ? (
                          <div>{sin_datos}</div>
                        ) : (
                          <div>
                            {historialRegistros.map((fila, key) => (
                              <Card
                                key={key}
                                style={{
                                  borderRadius: "10px",
                                  marginBottom: "10px",
                                }}
                              >
                                <CardHeader
                                  style={{ backgroundColor: "gainsboro" }}
                                  action={
                                    <IconButton
                                      style={{ color: "black" }}
                                      onClick={() => {
                                        DescargarRecibo(
                                          fila.PrecioSugerido,
                                          fila.FechaHoraSolicitud,
                                          fila.PartidaDireccion,
                                          fila.DestinoDireccion,
                                          fila.Pasajero,
                                          fila.Chofer,
                                          fila.Marca,
                                          fila.Modelo,
                                          fila.Color,
                                          fila.Dominio,
                                          fila.Estado,
                                          fila.ViajeId,
                                          fila.Kms,
                                          fila.Min
                                        );
                                      }}
                                    >
                                      <DownloadIcon />
                                    </IconButton>
                                  }
                                />
                                <CardContent style={{ marginTop: "-60px" }}>
                                  <b
                                    style={{
                                      fontSize: "x-large",
                                      color: "black",
                                    }}
                                  >
                                    $ {fila.PrecioSugerido}
                                  </b>
                                  <br></br>
                                  <small style={{ color: "black" }}>
                                    {fila.FechaHoraSolicitud}
                                  </small>
                                  <br></br>
                                  <br></br>
                                  <b>{punto_de_partida}</b>
                                  <br></br>
                                  <small>{fila.PartidaDireccion}</small>
                                  <br></br>
                                  <br></br>
                                  <b>{punto_destino}</b>
                                  <br></br>
                                  <small>{fila.DestinoDireccion}</small>
                                  <br></br>
                                  <br></br>
                                  <b>{pasajero}</b>
                                  <br></br>
                                  <small>{fila.Pasajero}</small>
                                  <br></br>
                                  <br></br>
                                  <b>{conductor}</b>
                                  <br></br>
                                  <small>
                                    {fila.Chofer}
                                    <br></br>
                                    {fila.Marca} {fila.Modelo} {fila.Color}
                                    <br></br>
                                    {fila.Dominio}
                                  </small>
                                  <br></br>
                                  <br></br>
                                  <small style={{ color: "gainsboro" }}>
                                    {fila.Estado}
                                  </small>
                                  <br></br>
                                  <small
                                    style={{
                                      textAlign: "center",
                                      color: "gainsboro",
                                    }}
                                  >
                                    # {fila.ViajeId}
                                  </small>
                                </CardContent>
                                <CardActions
                                  style={{
                                    backgroundColor: "#153B5E",
                                    color: "white",
                                  }}
                                >
                                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                  <IconButton>
                                    <IconoKms
                                      style={{ color: "white" }}
                                      fontSize="small"
                                    />
                                  </IconButton>
                                  <small>{fila.Kms} Kms</small>
                                  <IconButton>
                                    <IconoMin
                                      style={{ color: "white" }}
                                      fontSize="small"
                                    />
                                  </IconButton>
                                  <small>{fila.Min} min</small>
                                </CardActions>
                              </Card>
                            ))}
                          </div>
                        )}
                      </Box>
                    </Grid.Column>
                  </Grid.Row>
                </div>
              </Grid>
            </Segment>
          </Box>
        </Container>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleModal}>
            <VerReciboViaje
              PrecioSugerido={PrecioSugerido}
              FechaHoraSolicitud={FechaHoraSolicitud}
              PartidaDireccion={PartidaDireccion}
              DestinoDireccion={DestinoDireccion}
              Pasajero={Pasajero}
              Chofer={Chofer}
              Marca={Marca}
              Modelo={Modelo}
              Color={Color}
              Dominio={Dominio}
              Estado={Estado}
              ViajeId={ViajeId}
              Kms={Kms}
              Min={Min}
            ></VerReciboViaje>
          </Box>
        </Modal>
      </div>
      <ScrollTop {...props}>
        <Fab size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </div>
  );
}
